import {formatEventOccurrenceDate, formatMoney} from "../../../js/formatters";

export const createMapEventOccurrenceElement = (json: any): HTMLElement | null => {
  const template = document.getElementById('map-event-occurrence-template') as HTMLTemplateElement;
  if (!template) {
    return null
  }

  const clone = template.content.cloneNode(true) as HTMLElement;

  const eventOccurrenceLink = clone.querySelector<HTMLLinkElement>('[data-event-occurrence-path]');
  if (eventOccurrenceLink) eventOccurrenceLink.href += `/${json.event.id}?occurrence_id=${json.id}`;

  const eventTypePlaceholder = clone.querySelector('[data-event-type]');
  if (eventTypePlaceholder) eventTypePlaceholder.textContent = json.event.event_type.name;

  const occurrenceDarePlaceholder = clone.querySelector('[data-occurrence-date]');
  if (occurrenceDarePlaceholder) occurrenceDarePlaceholder.textContent = formatEventOccurrenceDate(json.occurrence_date);

  const organizerPlaceholder = clone.querySelector('[data-organizer]');
  if (organizerPlaceholder) {
    const organizer = [
      json.event.organizer?.last_name, json.event.organizer?.first_name, json.event.organizer?.middle_name
    ].filter(part => !!part).join(' ');

    if (organizer) {
      organizerPlaceholder.textContent = organizer;
    } else {
      organizerPlaceholder.parentElement?.remove();
    }
  }

  const infoPlaceholder = clone.querySelector('[data-occurrence-info]');
  const formattedText = json.event.short_description.replace(/\n\n/g, '\n').replace(/\n/g, ' • ');
  if (infoPlaceholder) infoPlaceholder.innerHTML = formattedText

  const minCostPlaceholder = clone.querySelector('[data-min-cost]');
  if (minCostPlaceholder) minCostPlaceholder.textContent = formatMoney(json.event.min_cost);

  return clone;
}